module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.dealId) ? _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressForm),
      expression: "progressForm"
    }],
    staticClass: "z-deal-status-changer",
    on: {
      "click": _vm.preventClick
    }
  }, [_c('z-select', {
    staticClass: "status-id",
    attrs: {
      "name": "status_id",
      "id": "status_id",
      "label": (_vm.$props.hideLabel ? '' : 'Статус заявки'),
      "disabled": _vm.$props.disabled
    },
    on: {
      "change": _vm.showChangeStatusDialog
    },
    model: {
      value: (_vm.form.status_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "status_id", $$v)
      },
      expression: "form.status_id"
    }
  }, _vm._l((_vm.dealStatuses), function(item) {
    return _c('option', {
      style: ('color:  ' + (item.color ? item.color : '#000') + '; font-weight: bold;'),
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('md-dialog', {
    attrs: {
      "md-active": _vm.changeStatusDialog,
      "md-theme": "white"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.changeStatusDialog = $event
      }
    }
  }, [_c('md-dialog-title', [_vm._v("Вы уверены в изменении статуса заявки?")]), _c('md-dialog-content', [(_vm.currentDealStatus && _vm.currentDealStatus.reasons && _vm.currentDealStatus.reasons.length) ? _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "status-reason",
    attrs: {
      "name": "reason_id",
      "id": "reason_id",
      "label": "Признак отмены",
      "error": _vm.errors.first('status.reason_id'),
      "data-vv-name": "reason_id",
      "data-vv-as": ' ',
      "data-vv-scope": "status"
    },
    model: {
      value: (_vm.form.reason_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "reason_id", $$v)
      },
      expression: "form.reason_id"
    }
  }, _vm._l((_vm.currentDealStatus.reasons), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _vm._e(), (_vm.currentDealStatusReason && parseInt(_vm.currentDealStatusReason.comment_require) === 1) ? _c('z-text-area', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "id": "change_message",
      "name": "change_message",
      "label": "Комментарий",
      "required": "required",
      "error": _vm.errors.first('status.change_message'),
      "data-vv-name": "change_message",
      "data-vv-as": ' ',
      "data-vv-scope": "status"
    },
    model: {
      value: (_vm.changeStatusMessage),
      callback: function($$v) {
        _vm.changeStatusMessage = $$v
      },
      expression: "changeStatusMessage"
    }
  }) : _vm._e()], 1), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.hideChangeStatusDialog
    }
  }, [_vm._v("Отмена")]), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.changeStatus(_vm.form.status_id, _vm.form.reason_id, _vm.changeStatusMessage)
      }
    }
  }, [_vm._v("Ок")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1a0ecc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZDealStatusChanger.vue
// module id = 1210
// module chunks = 0